import { AbstractControl } from '@angular/forms';
import { resourceLimits } from 'worker_threads';

import { Base, BaseDTO } from './base.model';


export interface TargetFilters {
  search?: string;
}

export interface TargetDTO extends BaseDTO {
  name: string;
 }
export class Target extends Base {
  name: string;

  constructor(source: TargetDTO) {
    super(source);
    if (source) {
      this.name = source.name;
    }
  }

  toDTO(): TargetDTO {
    let result: TargetDTO = <TargetDTO>super.toDTO();
    result.name = this.name;
    return result;
  }

  static fromFormGroup(formGroup: AbstractControl, original?: Target) {
    const formModel = formGroup.value;
    let target: Target = new Target(null);
    target.name = formModel.name;   
    if (original) {
      target.id = original.id;
    }
    return target;
  }

}
